






















































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import QForm from 'quasar/src/components/form/QForm.js';
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import WebUserAuthCard from '@/modules/user/components/web/auth/WebUserAuthCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import AuthRoute from '@/modules/user/routes/auth.route'
import Copyright from '@/modules/shared/components/panel/Copyright.vue'
import Logo from '@/modules/shared/components/shared/Logo.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import { UserPasswordResetRequestModel } from '@/modules/user/models/user-request.model'
import WebLayout from '@/modules/common/layout/components/web/WebLayout.vue'
import WebRoute from '@/modules/other/routes/web.route'
import { AuthService } from '@/modules/user/services/auth.service'


@Component({
  layout: WebLayout,
  metaInfo: {
    title: 'بازیابی رمز عبور'
  },
  components: {
    AlertNotification,
    Logo,
    Copyright,
    Checkbox,
    WebUserAuthCard,
    BaseCard,
    Heading,
    BaseInput,
    BaseButton
  }
})
export default class ResetPage extends Vue {
  constructor(
    private readonly routes: AuthRoute,
    private readonly services: AuthService,
    private readonly webRoutes: WebRoute
  ) {
    super()
  }

  message = ''
  resetModel: UserPasswordResetRequestModel = {
    email: ''
  }

  loading = false

  $refs!: {
    resetForm: QForm
  }

  passwordEmail() {
    this.loading = true
    this.$refs.resetForm.validate().then(success => {
      if (success) {
        this.services.passwordResetRequest(this.resetModel)
          .then((response) => {
            this.message = response['message'] //use apiResource : {message:string} TODO:need http useCase
            this.loading = false
          }).catch(() => {
          this.loading = false
        })
      } else this.loading = false
    })
  }

}
